/**
 * Created by pajicv on 10/7/18.
 */
import React from 'react';
import { connect } from 'react-redux';
import { Avatar, TextField, withStyles, Typography, Button, Card, CardContent, Icon } from '@material-ui/core';
import Dropzone from 'react-dropzone';
import Upload from '@material-ui/icons/CloudUpload';
import Download from '@material-ui/icons/CloudDownload';
import DocumentTags from '../common/DocumentTags';
import {
     getWorkerDocument, getTask,
    initPersonaDocument, updatePersonaDocumentsTags, updateDocumentDescription, updateDocumentTags, removeDocumentFromSubTask, updateSubTask
} from '../../firebase/db'
import { db } from '../../firebase/firebase';
import { downloadDoc } from '../../firebase/functions';
import { uploadPersonaDocument } from '../../firebase/storage'
import classNames from 'classnames'
import saveAs from 'file-saver';
import { removeTag } from '../../firebase/db'
import _ from 'lodash'
import swal from 'sweetalert2';
import { toast } from 'react-toastify'
const styles = theme => ({
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        alignContent: 'flex-start',
        flexDirection: 'column',
        width: '80%',
        paddingTop: 20
    },
    infoLine: {
        display: 'flex',
        alignItems: 'flex-start',
        alignContent: 'flex-start',
        width: '100%',
        height: 200
    },
    documents: {
        display: 'flex',
        flexWrap: 'wrap',
        marginLeft: -230,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
    },
    documentUpload: {
        display: 'flex',
        flexWrap: 'wrap',
        marginLeft: -416,
        marginTop: 40,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
    },
    textName: {
        fontSize: 12,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        width: 130,
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
    },
    items: {
        flex: 1
    },
    avatar: {
        marginLeft: 20
    },
    avatars: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        //minWidth: 300,
        width: 300
    },
    invite: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        width: 800
    },
    membersLine: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        width: '100%',
        height: 100,
        flex: 1,
        marginBottom: 10
    },
    dateField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    addButton: {
        width: 40,
        height: 20,
        marginTop: 10
    },
    card: {
        margin: 15,
        width: 150,
        height: 150,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        alignContent: 'flex-start'
    },
    cardContent: {
        flexDirection: 'column',
        alignItems: 'center',
    },
    button: {
        margin: 10
    },
    documentCardContainer: {
        margin: 40,
        position: 'relative',
    },
    deleteButton: {
        position: 'absolute',
        width: 40,
        height: 40,
        zIndex: 1001
    },
    addTags: {
        position: 'absolute',
        width: 40,
        height: 40,
        zIndex: 1001
    },
    extension: {
        margin: 30
    },
    text: {
        padding: 15
    },
    notesContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        marginLeft: 30
    },
});

class WorkerSubTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            popup: false,
            document: null,
            documentId: null,
            workerNotes: this.props.subTask.workerNotes,
            subTask: this.props.subTask
        };
    }

    componentDidMount() {
        const { subTaskId } = this.props;

        db.ref(`subTasks/${subTaskId}`).limitToLast(1).on('child_changed', () => {
            getTask(subTaskId)
                .then((subTask) => {
                    this.setState({
                        subTask: subTask[0]
                    })
                })
        });
        db.ref('documents').limitToLast(1).on('child_added', () => {
            getWorkerDocument(subTaskId)
                .then((document) => {
                    if (!!document && document[Object.keys(document)[0]].active === true) {
                        let documment = document[Object.keys(document)[0]];
                        let documentId = Object.keys(document)[0];
                        this.setState({ document: documment, documentId: documentId })
                    }
                    else {
                        this.setState({ document: null, documentId: null })
                    }
                    getTask(subTaskId)
                        .then((subTask) => {
                            this.setState({
                                subTask: subTask[0]
                            }, function () {
                                this.props.setSubTask(subTask[0]);
                            })
                        })
                })
        });
        db.ref('documents').limitToLast(1).on('child_changed', () => {
            getWorkerDocument(subTaskId)
                .then((document) => {
                    if (!!document && document[Object.keys(document)[0]].active === true) {
                        let documment = document[Object.keys(document)[0]];
                        let documentId = Object.keys(document)[0];
                        this.setState({ document: documment, documentId: documentId })
                    }
                    else {
                        this.setState({ document: null, documentId: null })
                    }
                    getTask(subTaskId)
                        .then((subTask) => {
                            this.setState({
                                subTask: subTask[0]
                            }, function () {
                                this.props.setSubTask(subTask[0]);
                            })
                        })
                })
        });
        db.ref('documents').on('child_removed', () => {
            this.setState({ document: null, documentId: null })
            getTask(subTaskId)
                .then((subTask) => {
                    this.setState({
                        subTask: subTask[0]
                    }, function () {
                        this.props.setSubTask(subTask[0]);
                    })
                })
        });
    }

    handleDropPicture = ({ accepted, rejected }) => {
        const { task, subTask, subTaskId, auth, cycleTitle, projectTitle } = this.props;
        if (rejected.length > 0) {
            toast.error("Unsuported file type or file too large!", {
                position: "top-center",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } else if (!!accepted && accepted.length !== 0) {
            initPersonaDocument(accepted[0], subTask.task, task.project, task.cycle, subTaskId, auth.email)
                .then((documentId) => {
                    uploadPersonaDocument(documentId, accepted[0], subTaskId, task.cycle)
                        .then(() => {
                            const array = [projectTitle, cycleTitle, task.name];
                            updatePersonaDocumentsTags(documentId, array, accepted[0].name.split('.').pop());
                        });
                });
        }
    }

    showDescription = () => {
        this.setState({ popup: !this.state.popup })
        this.props.onTagsOpen(!this.state.popup);

    }

    onCancelDialog = () => {
        this.setState({ popup: false });
        this.props.onTagsOpen(false);
    }

    handleTextFieldChange = (propertyName, field, value) => {
        this.setState((state) => {
            const property = state[propertyName];
            property[field] = value;
            return { ...state, property };
        });
    };

    removeDocumentFromSubTask = (name) => {
        const { subTaskId, onTagsOpen } = this.props;
        onTagsOpen(true);
        swal({
            title: `Wollen Sie das Dokument ${name} wirklich löschen?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#54be89',
            cancelButtonColor: '#ef6920',
            confirmButtonText: 'OK',
            cancelButtonText: 'CANCEL'
        }).then((result) => {
            if (result.value) {
                removeDocumentFromSubTask(subTaskId, this.state.documentId)
                    .then(() => {
                        this.setState({
                            document: null,
                            documentId: null,
                        })
                        return swal(
                            'Deleted!',
                            'The document has been deleted.',
                            'success'
                        )
                            .then(() => onTagsOpen(false))
                    })
                    .catch((error) => {
                        console.log(error);
                        onTagsOpen(false);
                    });
            } else {
                onTagsOpen(false);
            }
        });
    }

    sendTags = (tags) => {
        if (Array.isArray(this.state.document['tags'])) {
            let diff = _.difference(this.state.document['tags'], tags);
            diff.map((tag) => {
                removeTag(this.state.documentId, tag);
            })
        } else {
            let diff2 = _.difference(Object.keys(this.state.document['tags']), tags);
            diff2.map((tag) => {
                removeTag(this.state.documentId, tag);
            })
        }
        this.setState((state) => {
            const property = state.document;
            property['tags'] = tags;
            return { ...state, property };
        }, function () {
            if (Array.isArray(this.state.document.tags)) {
                this.state.document.tags.forEach((tag) => {
                    updateDocumentTags(this.state.documentId, tag);
                })
            } else {
                Object.keys(this.state.document.tags).map((key) => {
                    return updateDocumentTags(this.state.documentId, key)
                })
            }
        })
    }


    onCloseDescription = () => {
        this.setState({ popup: false })
        this.props.onTagsOpen(false);
    }

    handleNotesBlur = () => {
        const { subTaskId } = this.props;
        const { workerNotes } = this.state;
        updateSubTask(subTaskId, 'workerNotes', workerNotes);
    };

    handleNotesFieldChange = (field, value) => {
        this.setState({ [field]: value });
    };

    downloadDocument = (filename, filePath) => {
        downloadDoc(filename, filePath)
            .then((response) => {
                saveAs(new Blob([response.data]), filename);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    componentWillUnmount() {
        const { subTask, subTaskId } = this.props;
        const { workerNotes } = this.state;
        if (subTask.workerNotes !== workerNotes) {
            updateSubTask(subTaskId, 'workerNotes', workerNotes);
        }
    }

    render() {
        const { classes, task, subTaskId, auth } = this.props;
        const { subTask } = this.state;
        const { workerNotes } = this.state;
        let iconName = 'file';
        if (this.state.document) {
            switch (this.state.document.name.split('.').pop().toLowerCase()) {
                case 'jpg': case 'jpeg': case 'bpm': case 'tiff': case 'gif': case 'png': case 'svg':
                    iconName = 'file-image';
                    break;
                case 'pdf':
                    iconName = 'file-pdf';
                    break;
                case 'zip':
                    iconName = 'file-archive';
                    break;
                case 'doc': case 'docx': case 'odt':
                    iconName = 'file-word';
                    break;
                case 'xls': case 'xlsx': case 'csv':
                    iconName = 'file-excel';
                    break;
            }
        }
        return (
            <div>
                <div className={classes.container}>
                    <div className={classes.infoLine}>
                        <div className={classes.notesContainer}>
                            <TextField
                                label="Manager Notizen"
                                multiline
                                style={{ width: '460px' }}
                                rows="7"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={true}
                                margin="normal"
                                variant='outlined'
                                value={subTask.notes}
                            />
                            <TextField
                                label="Bearbeiter Notizen"
                                multiline
                                rows="7"
                                style={{ width: '460px' }}
                                disabled={subTask.assignedTo != window.btoa(auth.email)}
                                margin="normal"
                                variant='outlined'
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={workerNotes}
                                onChange={(e) => this.handleNotesFieldChange('workerNotes', e.target.value)}
                                onBlur={this.handleNotesBlur}
                            />
                        </div>
                    </div>
                    <div className={classes.items}>
                        {!this.state.document &&
                            <div className={classes.documentUpload}>
                                {subTask.assignedTo === window.btoa(auth.email) &&
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <Dropzone
                                            accept={['image/tiff', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                                'application/pdf', 'text/csv', 'application/zip', 'audio/*', '.ppt', '.pptx']}
                                            maxSize={10485760}
                                            className="dropZone-profile"
                                            multiple={false}
                                            onDrop={(accepted, rejected) => this.handleDropPicture({ accepted, rejected })}
                                        >
                                            {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
                                                return <Button
                                                    variant="fab"
                                                    color="primary"
                                                    aria-label="Add"
                                                >
                                                    <Upload />
                                                </Button>
                                            }}
                                        </Dropzone>
                                        <Typography className={classes.text}>Upload {task.name}</Typography>
                                    </div>
                                }
                            </div>
                        }
                        <div className={classes.documents}>
                            {this.state.document &&
                                <div className={classes.documents}>
                                    <div className={classes.documentCardContainer}>
                                        <Typography style={{ marginLeft: '15px' }}>Fertiges Dokument</Typography>
                                        <Card className={classes.card}>
                                            <CardContent className={classes.cardContent}>
                                                <Icon
                                                    className={classNames(classes.icon, `fa fa-${iconName}`)}
                                                    color="primary"
                                                    fontSize="large"
                                                />
                                                <div className={classes.textName} >
                                                    {this.state.document.name}
                                                </div>
                                                <div className={classes.textName} >
                                                    {'Upload' + ': ' + (new Date(this.state.document.uploadDate)).toLocaleDateString('de-AT')}
                                                </div>
                                                {subTask.assignedTo === window.btoa(auth.email) &&
                                                    <div style={{ backgroundColor: '#c5c2c2', height: '40px', width: '150px', display: 'flex', flexDirection: 'row', marginLeft: '-24px', marginTop: '27px', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <div style={{ cursor: 'pointer', color: 'white', marginLeft: '10px' }}
                                                            onClick={() => this.removeDocumentFromSubTask(this.state.document.name)}
                                                        >
                                                            <img src={require('../../icons/trash.svg')} height="20" width="20" />
                                                        </div>
                                                        <div style={{ cursor: 'pointer' }}
                                                            onClick={() => this.showDescription()}
                                                        >
                                                            <img src={require('../../icons/ribbon.svg')} height="20" width="20" />
                                                        </div>
                                                        <div style={{ cursor: 'pointer', marginRight: '10px' }}
                                                            onClick={() => this.downloadDocument(this.state.document.name, `documents/${this.state.documentId + '/' + this.state.document.name}`)}
                                                        >
                                                            <Download />
                                                        </div>
                                                    </div>
                                                }
                                            </CardContent>
                                        </Card>
                                    </div>
                                </div>
                            }
                        </div>


                        {this.state.popup &&
                            <DocumentTags
                                visible={this.state.popup}
                                tags={this.state.document.tags}
                                description={this.state.document.description}
                                onCancel={this.onCancelDialog}
                                onTagsChange={(tags) => this.sendTags(tags)}
                                onDescriptionChange={(e) => this.handleTextFieldChange('document', 'description', e.target.value)}
                                onDescriptionBlur={(e) => updateDocumentDescription(this.state.documentId, e.target.value)}
                                onConfirm={this.onCloseDescription} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(connect(state => ({
    auth: state.firebase.auth,
}))(WorkerSubTask));



// WEBPACK FOOTER //
// ./src/components/Tasks/WorkerSubTask.js